/**
 * player_models.ts — the scanned player-avatar roster (Higgsfield GLBs,
 * generations goal 2026-07-22).
 *
 * A traveler may wear one of these instead of the primitive body templates.
 * The choice replicates to EVERYONE through the avatar row's `attachments`
 * record (`{ model: 'avatar:player_…' }`) — the server's P1 validation
 * already accepts arbitrary point→ref strings, so no schema change; remotes
 * resolve the prefab key to a render asset and wear the GLB.
 */
import type { DbConnection } from '../module_bindings/index.js';

export const PLAYER_MODELS: Array<{ key: string; label: string }> = [
  { key: 'avatar:player_pathfinder', label: 'PATHFINDER' },
  { key: 'avatar:player_circuitwright', label: 'CIRCUITWRIGHT' },
  { key: 'avatar:player_skywarden', label: 'SKYWARDEN' },
  { key: 'avatar:player_verdant', label: 'VERDANT' },
  { key: 'avatar:player_nightcourier', label: 'NIGHTCOURIER' },
  // 20-preset wave (2026-07-24) — fifteen more scanned humans.
  { key: 'avatar:player_medica', label: 'MEDICA' },
  { key: 'avatar:player_forgemaster', label: 'FORGEMASTER' },
  { key: 'avatar:player_tidewalker', label: 'TIDEWALKER' },
  { key: 'avatar:player_archivist', label: 'ARCHIVIST' },
  { key: 'avatar:player_duskranger', label: 'DUSKRANGER' },
  { key: 'avatar:player_stellarch', label: 'STELLARCH' },
  { key: 'avatar:player_gearhart', label: 'GEARHART' },
  { key: 'avatar:player_lumenweaver', label: 'LUMENWEAVER' },
  { key: 'avatar:player_quarrier', label: 'QUARRIER' },
  { key: 'avatar:player_skysong', label: 'SKYSONG' },
  { key: 'avatar:player_voltkeeper', label: 'VOLTKEEPER' },
  { key: 'avatar:player_frostrunner', label: 'FROSTRUNNER' },
  { key: 'avatar:player_emberchef', label: 'EMBERCHEF' },
  { key: 'avatar:player_starling', label: 'STARLING' },
  { key: 'avatar:player_stonewright', label: 'STONEWRIGHT' },
];

/** Portrait thumbnail (vite public/) for a preset card — the source Higgsfield
 *  render, downscaled by tools/asset-pipeline/make-avatar-thumbs.mjs. */
export function modelThumbPath(key: string): string {
  return `/avatars/${key.slice('avatar:player_'.length)}.png`;
}

/** The scanned-model key an appearance wears, or null for primitive bodies. */
export function modelKeyOf(attachments: Record<string, string> | null | undefined): string | null {
  const k = attachments?.model;
  return typeof k === 'string' && k.startsWith('avatar:player_') ? k : null;
}

/** Resolve a prefab key to its render asset id (null until the catalog lands). */
export function prefabAssetId(conn: DbConnection, prefabKey: string): bigint | null {
  for (const pm of conn.db.prefabModel.iter()) {
    if (pm.prefabKey === prefabKey) return pm.assetId;
  }
  return null;
}
